










































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class ComponentNoticeBox extends Vue {
  @Prop({required: true})
  private pageName!: string;

  @Prop({required: true})
  private payType!: string;

  private get isCancelApply(){
    return this.pageName === 'CancelPopup'
  }

  private get isExchangeBeforeApply(){
    return this.pageName === 'ExchangePopupBefore'
  }

  private get isExchangeAfterApply(){
    return this.pageName === 'ExchangePopupAfter'
  }

  private get isReturnApply(){
    return this.pageName === 'ReturnPopup'
  }

  private get isNaverPay(){
    return this.payType === 'NAVER_PAY'
  }
}
